import { z } from 'zod'

export enum ReportPeriodType {
  LAST_7_DAYS = 'last_7_days',
  LAST_30_DAYS = 'last_30_days',
  LAST_3_MONTHS = 'last_3_months',
  LAST_6_MONTHS = 'last_6_months',
  LAST_YEAR = 'last_year',
  LAST_2_YEARS = 'last_2_years',
  LAST_3_YEARS = 'last_3_years',
  LAST_5_YEARS = 'last_5_years',
  THIS_MONTH = 'this_month',
  THIS_YEAR = 'this_year',
}

export const PERIOD_LABELS: Record<ReportPeriodType, string> = {
  [ReportPeriodType.LAST_7_DAYS]: 'Últimos 7 días',
  [ReportPeriodType.LAST_30_DAYS]: 'Últimos 30 días',
  [ReportPeriodType.LAST_3_MONTHS]: 'Últimos 3 meses',
  [ReportPeriodType.LAST_6_MONTHS]: 'Últimos 6 meses',
  [ReportPeriodType.LAST_YEAR]: 'Último año',
  [ReportPeriodType.LAST_2_YEARS]: '2 años',
  [ReportPeriodType.LAST_3_YEARS]: '3 años',
  [ReportPeriodType.LAST_5_YEARS]: '5 años',
  [ReportPeriodType.THIS_MONTH]: 'Este mes',
  [ReportPeriodType.THIS_YEAR]: 'Este año',
}

export interface AccountReportView {
  id: string
  name: string
  description: string | null
  accountIds: string[]
  periodType: ReportPeriodType
  createdBy: string
  createdAt: Date
  updatedAt: Date
}

export const reportViewFormSchema = z.object({
  name: z.string().min(1, 'El nombre es obligatorio'),
  description: z.string().optional(),
  accountIds: z.array(z.string()).min(1, 'Seleccioná al menos una cuenta'),
  periodType: z.nativeEnum(ReportPeriodType),
})

export type ReportViewFormValues = z.infer<typeof reportViewFormSchema>

/** Returns the [fromDate, toDate] Date pair for a given period type */
export const resolvePeriodDates = (periodType: ReportPeriodType): { from: Date; to: Date } => {
  const to = new Date()
  const from = new Date()

  switch (periodType) {
    case ReportPeriodType.LAST_7_DAYS:
      from.setDate(to.getDate() - 7)
      break
    case ReportPeriodType.LAST_30_DAYS:
      from.setDate(to.getDate() - 30)
      break
    case ReportPeriodType.LAST_3_MONTHS:
      from.setMonth(to.getMonth() - 3)
      break
    case ReportPeriodType.LAST_6_MONTHS:
      from.setMonth(to.getMonth() - 6)
      break
    case ReportPeriodType.LAST_YEAR:
      from.setFullYear(to.getFullYear() - 1)
      break
    case ReportPeriodType.LAST_2_YEARS:
      from.setFullYear(to.getFullYear() - 2)
      break
    case ReportPeriodType.LAST_3_YEARS:
      from.setFullYear(to.getFullYear() - 3)
      break
    case ReportPeriodType.LAST_5_YEARS:
      from.setFullYear(to.getFullYear() - 5)
      break
    case ReportPeriodType.THIS_MONTH:
      from.setDate(1)
      from.setHours(0, 0, 0, 0)
      break
    case ReportPeriodType.THIS_YEAR:
      from.setMonth(0, 1)
      from.setHours(0, 0, 0, 0)
      break
  }

  return { from, to }
}
